'use strict';

module.exports = 'year|month|week|day|hour|minute|second|millisecond';


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar-date/range/var/DURATION_UNITS.js
// module id = 65
// module chunks = 1